import oneDRAWWhiteLogo from "../../../../assets/img/logos/one_draw_logo_white.png";
import oneDRAWDarkLogo from "../../../../assets/img/logos/one_draw_logo.png";

import {Link} from "react-router-dom";
import React, {useContext} from "react";
import {ThemeContext} from "../../../../contexts/ThemeContext";
import {useCurrentUser} from "../../../../contexts/UserContext";

const Logo = () => {
    const {hasCapability} = useCurrentUser();
    const {theme} = useContext(ThemeContext);
    return (
        <>
            {hasCapability('Sites_Table') ? //Enable link to sites table if user has permission
                <Link to="/" className='header__logo'>
                    <img
                        src={theme === 'dark' ? oneDRAWWhiteLogo : oneDRAWDarkLogo}

                        alt='OneDraw'/>
                </Link>
                : <img className='header__logo'
                src={theme === 'dark' ? oneDRAWWhiteLogo : oneDRAWDarkLogo}

                alt='OneDraw'/>
            }
        </>
    )
}

export default Logo;